import React from 'react';

interface BrandLogoProps {
  tone?: 'on-dark' | 'on-light' | 'footer';
  className?: string;
}

export const BrandLogo: React.FC<BrandLogoProps> = ({ tone = 'on-light', className = '' }) => {
  const shellToneClasses = {
    'on-dark': 'bg-white/95 border-white/60 shadow-xl shadow-slate-950/30',
    'on-light': 'bg-white border-slate-200/90 shadow-sm',
    'footer': 'bg-white/95 border-white/20 shadow-xl shadow-slate-950/30'
  };

  const shellSizeClasses = {
    'on-dark': 'p-1.5 max-[360px]:p-1 max-[360px]:rounded-xl',
    'on-light': 'p-1.5 max-[360px]:p-1 max-[360px]:rounded-xl',
    'footer': 'p-1.5 max-[360px]:p-1.5'
  };

  const imageSizeClasses = {
    'on-dark': 'h-10 sm:h-11 w-auto object-contain max-[360px]:h-8 max-[360px]:w-[80px] max-[360px]:max-w-none max-[360px]:object-cover max-[360px]:object-[center_48%]',
    'on-light': 'h-10 sm:h-11 w-auto object-contain max-[360px]:h-8 max-[360px]:w-[80px] max-[360px]:max-w-none max-[360px]:object-cover max-[360px]:object-[center_48%]',
    'footer': 'h-11 sm:h-12 w-auto object-contain max-[360px]:h-9'
  };

  return (
    <span className={`inline-flex items-center rounded-2xl border transition-all duration-300 ${shellToneClasses[tone]} ${shellSizeClasses[tone]} ${className}`.trim()}>
      <img
        src="/a2-innovation.jpeg"
        alt="A2 Innovations Inc."
        className={imageSizeClasses[tone]}
        width={250}
        height={120}
        loading={tone === 'footer' ? 'lazy' : 'eager'}
        decoding="async"
      />
    </span>
  );
};